import { required, maxLength } from "validators/validation";

const validators = {
	title: {
		required,
		maxLength: maxLength(100),
	},
	category: {
		required,
	},
	note: {
		required,
		maxLength: maxLength(2000),
	},
	phase: {
		required,
	},
};

export default validators;
